<template>
  <header class="header">
    <AppHeaderCompanyInfo />
    <AppHeaderStaffInfo />
  </header>
</template>

<script>

import AppHeaderStaffInfo from './Header/AppHeaderStaffInfo'
import AppHeaderCompanyInfo from './Header/AppHeaderCompanyInfo'

export default {
  components: {
    AppHeaderStaffInfo, AppHeaderCompanyInfo
  }
}
</script>

<style lang="scss" scoped>
.header {
  z-index: 900;
  position: relative;
}
</style>
